import { React, useEffect } from "react";
import SVGraphics from "../../assets/SVGraphics";
import '../../style/SystemMessage.css'

const SystemMessage = (props) => {
  const { handleClose, message, title, type = "success", key } = props;

  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, 8000);

    return () => clearTimeout(timer);
  }, []);


  const getSvgName = () => {
    switch (type) {
      case "success":
        return "successIcon";
      case 'error':
        return 'errorIcon';
      case 'message':
        return 'messageIcon';
      case 'warning':
        return 'warningIcon';
      default:
        return 'successIcon';
    }
  };

  return (
    <div key={key} onClick={() => handleClose()} className="systemMessage cursor-pointer text-white flex absolute items-center h-[66px] box-border w-fit pt-[14px] pr-[14px] pb-[14px] pl-[12px] left-1/2 z-[1000] rounded-[15px] bg-gray-800-opacity-30 border-gradient-custom-systemMessage">
      <div className="messageIcon w-[50px] box-border h-100">
        <SVGraphics svgname={getSvgName()} width='32px' height='32px'/>
      </div>
      <div className="textSection flex flex-col min-w-[290px] w-fit">
        <div className="title text-[15px] font-semibold">{title}</div>
        <div className="text text-[15px] font-normal ">{message}</div>
      </div>
      <div className="closeMessage w-[25px] flex justify-end items-center">
        <SVGraphics svgname="MessageClose" width='11px' height='12px'/>
      </div>
    </div>
  );
};

export default SystemMessage;
